import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private loader: HTMLIonLoadingElement | null = null;
  private httpCallStack = 0;
  private loaderPending = false;
  private loaderGeneration = 0;
  private blockedLoaderRoutes: string[] = [
    'api/v0/auth/alive',
    'api/v0/binary/construction-day-report/content',
    'api/v0/binary/hour-overview/content',
    'api/v0/binary/inspection/content',
    'api/v0/company/getLastDataUpdates',
    'api/v0/binary/document/previewImage',
  ];
  private showLogs = true;
  constructor(private loadingController: LoadingController) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.blockedLoaderRoutes.some((route) => request.url.includes(route))) {
      return next.handle(request);
    }

    void this.showLoader();
    return next.handle(request).pipe(finalize(() => this.hideLoader()));
  }

  private async showLoader() {
    if (this.showLogs)
      console.log('showLoader called, httpCallStack: ' + this.httpCallStack);
    this.httpCallStack++;
    if (this.loader || this.loaderPending || document.hidden) {
      return;
    }
    this.loaderPending = true;
    const generation = ++this.loaderGeneration;
    let createdLoader: HTMLIonLoadingElement | null = null;
    try {
      createdLoader = await this.loadingController.create({
        spinner: 'circular',
        backdropDismiss: false,
      });
      if (generation !== this.loaderGeneration || this.httpCallStack === 0) {
        createdLoader.remove();
        return;
      }
      await createdLoader.present();
      if (generation !== this.loaderGeneration || this.httpCallStack === 0) {
        await this.dismissLoader(createdLoader);
        return;
      }
      this.loader = createdLoader;
    } catch {
      if (createdLoader) {
        await this.dismissLoader(createdLoader);
      }
    } finally {
      if (generation === this.loaderGeneration) {
        this.loaderPending = false;
      }
    }
  }

  private hideLoader() {
    if (this.showLogs)
      console.log('hideLoader called, httpCallStack: ' + this.httpCallStack);
    this.httpCallStack--;
    if (this.httpCallStack === 0) {
      this.closeLoader();
    }
  }

  private closeLoader() {
    this.loaderGeneration++;
    this.loaderPending = false;
    const loader = this.loader;
    this.loader = null;
    if (loader) {
      void this.dismissLoader(loader);
    }
  }

  private async dismissLoader(loader: HTMLIonLoadingElement) {
    try {
      await loader.dismiss();
    } catch {
    } finally {
      loader.remove();
    }
  }
}
